import { getUserPermissions } from '~/api/permissions';
import { setUserPermissions } from '~/actions/permissions';
import { getEmail } from '~/selectors';

export const fetchUserPermissions = () => async (dispatch, getState) => {
  const state = getState();
  const email = getEmail(state);

  if (!email) {
    return;
  }

  const permissions = await getUserPermissions(email);

  dispatch(setUserPermissions({ permissions }));
};
